/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
  Paper,
  Dialog
} from '@material-ui/core';

import axios from 'axios';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from 'components/Button/button';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import { LocalizationPlainText } from 'components/Localization';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import * as UserActions from 'store/actions/user';
import Environment from 'utils/environments';
import getOptions from 'services/getOptions';
import { Autocomplete } from '@material-ui/lab';

function PaperComponent(props) {
  return (
    <Draggable handle="#storeDialog" cancel='[class*="MuiDialogContent-root"]'>
      <Paper {...props} />
    </Draggable>
  );
}

function StoreDialog({ userInfo, open, store, onClose, onSuccess }) {
  const environments = Environment(process.env.REACT_APP_ENV);
  const userLocal = JSON.parse(localStorage.getItem('companies'));

  const [formData, setFormData] = useState({
    description: store?.companyName || '',
    flags: store?.flags || []
  });
  const [flagOptions, setFlagOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    description: false,
    flags: false
  });
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  const isDisabledSubmit = () => {
    if (!store) return false;

    return Object.keys(formData).every((key) => formData[key] === store[key]);
  };

  const validFields = (body) => {
    const isAllValid = {
      description: !body.description,
    };

    setInvalidFields(isAllValid);

    return !isAllValid.description;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!validFields(formData)) return;

    const body = {
      description: formData?.description,
      flagIds: formData?.flags,
      restaurantId: userInfo?.companiesActive?.id,
      restaurantMasterId: userLocal?.labelId,
      user: userInfo.user
    };

    setLoading(true);

    if (store) {
      axios
        .put(
          `${environments.catalog}/flagsRestaurants/${store?.companyId}`,
          body,
          config
        )
        .then(() => {
          setLoading(false);
          onSuccess();
          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
        })
        .catch((error) => {
          setLoading(false);
          setMessage({
            description: error.response.data.message,
            status: 'error'
          });
        });
    } else {
      axios
        .post(`${environments.catalog}/flagsRestaurants`, body, config)
        .then((res) => {
          setLoading(false);
          onSuccess();
          onClose &&
            setTimeout(() => {
              onClose();
            }, 1000);
        })
        .catch((error) => {
          setMessage({
            description: error.response.data.message,
            status: 'error'
          });
          setLoading(false);
        });
    }
  };

  return (
    <Dialog
      className="defaultModal storeDialog dialog60"
      open={open}
      onClose={onClose}
      aria-labelledby="storeDialog"
      transitionDuration={0}
      PaperComponent={PaperComponent}
    >
      <DialogTitle className="modalHeader lightBlue" id="storeDialog">
        <Typography>
          {store ? 'Edição de Lojas' : 'Cadastro de Lojas'}
        </Typography>

        <IconButton
          id="closeStoreDialogInput"
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <img style={{ width: '16px' }} src={CloseIconNavy} alt="CloseIcon" />
        </IconButton>
      </DialogTitle>

      {loading ? <LinearProgress /> : null}

      <DialogContent className="modalContent pt26">
        <Grid className="m0" container xs={12} sm={12} spacing={4}>
          <Grid item xs={5} sm={5} className="pl0 pb0">
            <TextField
              key="descriptionStoreDialogInput"
              id="descriptionStoreDialogInput"
              name="description"
              size="small"
              label={LocalizationPlainText('description', 'translations')}
              variant="outlined"
              fullWidth
              required
              value={formData?.description}
              onChange={handleChange}
              className={`textFieldSmall backgroundInput ${
                invalidFields?.description && 'labelError'
              }`}
              disabled
              placeholder={LocalizationPlainText('TypeHere', 'translations')}
              tabIndex={0}
            />
          </Grid>

          <Grid item xs={7} sm={7} className="pl0 pr0 pb0">
            <Autocomplete
              options={flagOptions}
              getOptionLabel={(option) => option?.description}
              className={`autocompleteSmall backgroundInput ${
                invalidFields?.flags && 'labelError'
              }`}
              onFocus={() =>
                getOptions(
                  `${environments.catalog}/flags`,
                  'flags',
                  flagOptions,
                  setFlagOptions,
                  userLocal?.labelId
                )
              }
              multiple
              size="small"
              limitTags={2}
              value={formData?.flags}
              onChange={(_event, value) => {
                setFormData((prev) => ({
                  ...prev,
                  flags: value
                }));
              }}
              getOptionDisabled={(option) => {
                const currentFlags = formData?.flags;

                return currentFlags?.some(
                  (item) =>
                    (item?.id || item?._id) === (option?.id || option?._id)
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  id={params.id}
                  type="text"
                  name="flags"
                  label="Marcas"
                  variant="outlined"
                  placeholder="Selecione..."
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              )}
              renderOption={(params) => (
                <Typography
                  style={{
                    fontSize: '12px',
                    fontFamily: 'Lato'
                  }}
                >
                  {params.description}
                </Typography>
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="dialogActions pr12 pl12 pb12">
        <Button
          id="cancelStoreDialogButton"
          label="Voltar"
          className="defaultButton backButton mr20"
          onClick={onClose}
        />

        <Button
          id="submitStoreDialogButton"
          label="Salvar"
          className={`defaultButton submitButton ${
            (isDisabledSubmit() || loading) && 'disabledButton'
          }`}
          onClick={handleSubmit}
          disabled={isDisabledSubmit() || loading}
        />
      </DialogActions>

      <CommonAlert
        open={!!message.description}
        severity={message.status}
        onClose={() => setMessage({ description: '', status: '' })}
        messagePersonal={message.description}
        autoHideDuration={2000}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StoreDialog);
